import appGlobalScript from '/home/vsts/work/1/s/packages/components/src/global-prod.ts';
export const globalScripts = appGlobalScript;
